import {Navigate, Outlet} from 'react-router-dom'
import {routes} from '@/utilities/constants'
import {useAuthStore} from '@/store/useAuthStore.tsx'

export const PublicRoute = () => {
    const {accessToken} = useAuthStore()

    return accessToken ? <Navigate to={routes.HOME.path} /> : <Outlet />
}
